<template>
  <div class="goods-stretch-comp" :class="[subTitle.replace(/\s+/g, '')]">
    <div class="click-btn pos-center" @click="show = !show">
      <i></i>
      <span>{{ $t('good_stretch.title') }}</span>
    </div>
    <div class="goods-list" v-show="show">
      <div class="chevron pos-center">
        <i></i>
      </div>
      <div class="chevron pos-center chevron_1">
        <i></i>
      </div>
      <div class="list-wrapper c-layout">
        <!-- Swiper -->
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <router-link
              :to="{name:'goodsDetail',query:{goods_id:item.id}}"
              class="swiper-slide"
              v-for="(item,index) in list"
              :key="index"
            >
              <!-- <div class="goods-item">
                <img :src="item.photo" :alt="item.name" />
                <div class="goods-item__bottom">
                  <div class="tx1">
                    <span class="tx2">節庆优惠</span> | 精选內衣
                  </div>
                  <div class="pos-y">
                    <span class="tx3"></span>
                    <span class="tx4">5折</span>
                  </div>
                  <div class="tx5">{{ $t('good_stretch.shop_now') }} ></div>
                </div>
              </div> -->
              <GoodsItem :item="item" @addcart="handleOpenAddCartDrawer" />
            </router-link>
            
            <!-- <router-link
              :to="{name:'goodsDetail',query:{goods_id:item.id}}"
              class="swiper-slide"
              v-for="(item,index) in list"
              :key="index"
            >
              <div class="goods-item">
                <img :src="item.photo" :alt="item.name" />
                <div class="goods-item__bottom">
                  <div class="tx1">
                    <span class="tx2">節庆优惠</span> | 精选內衣
                  </div>
                  <div class="pos-y">
                    <span class="tx3">最 低</span>
                    <span class="tx4">5折</span>
                  </div>
                  <div class="tx5">即刻选购 ></div>
                </div>
              </div>
            </router-link>
            <router-link
              :to="{name:'goodsDetail',query:{goods_id:item.id}}"
              class="swiper-slide"
              v-for="(item,index) in list"
              :key="index"
            >
              <div class="goods-item">
                <img :src="item.photo" :alt="item.name" />
                <div class="goods-item__bottom">
                  <div class="tx1">
                    <span class="tx2">節庆优惠</span> | 精选內衣
                  </div>
                  <div class="pos-y">
                    <span class="tx3">最 低</span>
                    <span class="tx4">5折</span>
                  </div>
                  <div class="tx5">即刻选购 ></div>
                </div>
              </div>
            </router-link>
            <router-link
              :to="{name:'goodsDetail',query:{goods_id:item.id}}"
              class="swiper-slide"
              v-for="(item,index) in list"
              :key="index"
            >
              <div class="goods-item">
                <img :src="item.photo" :alt="item.name" />
                <div class="goods-item__bottom">
                  <div class="tx1">
                    <span class="tx2">節庆优惠</span> | 精选內衣
                  </div>
                  <div class="pos-y">
                    <span class="tx3">最 低</span>
                    <span class="tx4">5折</span>
                  </div>
                  <div class="tx5">即刻选购 ></div>
                </div>
              </div>
            </router-link> -->
          </div>
        </div>
      </div>
    </div>
    <AddCartDrawer ref="drawer"/>
  </div>
</template>

<script>
import GoodsItem from "../GoodsItem";
import AddCartDrawer from '../../components/AddCardDrawer/index.vue'

export default {
  props: ["list", "subTitle"],
  data() {
    return {
      show: true,
    };
  },
  mounted() {},
  methods: {
    initSwiper() {
      let { subTitle } = this;
      subTitle = subTitle.replace(/\s+/g, "");
      let nextEl = `.${subTitle} .chevron_1`;
      let prevEl = `.${subTitle} .chevron_0`;
      const screemW = document.body.clientWidth || document.documentElement.clientWidth;
      setTimeout(() => {
        const swiperOption = {
          slidesPerView: 4,
          spaceBetween: 30,
          slidesPerGroup: 4,
          // loop: true,
          loopFillGroupWithBlank: true,
          navigation: {
            nextEl,
            prevEl,
          },
        };
        if(screemW<992) {
          swiperOption.slidesPerView = 2;
          swiperOption.slidesPerGroup = 2;
        }
        new Swiper(`.${subTitle} .swiper-container`, swiperOption);
      }, 100);
    },
    async handleOpenAddCartDrawer(pid) {
      // this.choosePid = pid;
      this.$refs.drawer.handleOpenAddCartDrawer(pid);
    },
  },
  watch: {
    list() {
      this.initSwiper();
    },
  },
  components: {
    GoodsItem,
    AddCartDrawer
  },
};
</script>

<style scoped lang='less'>
.goods-stretch-comp {
  overflow: hidden;
  a {
    text-decoration: none;
  }
  .click-btn {
    cursor: pointer;
    margin: 0 auto;
    display: flex;
    width: 160px;
    height: 40px;
    background: var(---unnamed-color-ec4f00);
    border-radius: 10px 10px 0px 0px;

    font-size: 16px;
    line-height: 13px;
    color: var(--unnamed-color-ffffff);

    i {
      margin-top: 5px;
      width: 23px;
      height: 23px;
      background: url("./images/local_offer-24px@2x.png") no-repeat;
      background-size: contain;
      background-position: center center;
    }
  }
  .goods-list {
    position: relative;
    border-top: 1px solid var(--unnamed-color-e6e6e6);
    padding-top: 55px;
    padding-bottom: 55px;
    .list-wrapper {
      display: flex;
      // padding: 0 78px;
      .goods-item {
        cursor: pointer;
        width: 255px;
        margin-right: 30px;
        img {
          width: 100%;
          // height: 172px;
          display: block;
        }
        .goods-item__bottom {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-around;
          width: 255px;
          height: 125px;
          padding-top: 10px;
          padding-bottom: 15px;
          border: 1px solid var(--unnamed-color-e6e6e6);
          border-top: 0px solid var(--unnamed-color-e6e6e6);
          color: var(--unnamed-color-111111);
          .tx1 {
            font-size: 16px;
            line-height: 24px;
            font-weight: 700;
          }
          .tx2 {
            color: var(---unnamed-color-ec4f00);
          }
          .tx3 {
            margin-right: 5px;
            writing-mode: vertical-rl;

            font-size: 13px;
            line-height: 13px;
            font-weight: 700;
          }
          .tx4 {
            font-size: 24px;
            line-height: 36px;
            font-weight: 700;

            letter-spacing: var(--unnamed-character-spacing-0);
            color: #cc3333;
          }
          .tx5 {
            font-size: 13px;
            line-height: 20px;
            color: var(--unnamed-color-111111);
          }
        }
      }
    }
  }
  .chevron {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    z-index: 5;
    width: 30px;
    height: 55px;
    background: rgba(0, 0, 0, 0.267);
    i {
      width: 31px;
      height: 31px;
      background: url("~@/common/images/chevron_left-24px@2x.png") no-repeat;
      background-size: contain;
      background-position: center center;
    }
  }
  .chevron_1 {
    position: absolute;
    left: 100%;
    top: 50%;
    transform: translate(-30px, -50%);
    i {
      transform: rotate(180deg);
    }
  }
  .chevron:hover {
    background: rgba(0, 0, 0, 0.667);
  }
  @media (max-width:992px) {
    .goods-list {
      padding: 0 20px;
      .list-wrapper {
        .goods-item {
          width: 100%;
          height: auto;
          position: relative;
          img {
            width: 100%;
            height: auto;
          }
          .goods-item__bottom {
            width: 100%;
          }
        }
      }
    }
  }
}
::v-deep {
  .swiper-container {
    width: 100%;
    height: 100%;
  }
}
</style>
